import React from "react";
import { default as MuiFormGroup } from "@mui/material/FormGroup";

function FormGroup(props) {
  return <MuiFormGroup {...props} />;
}

export default FormGroup;
